/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createEnum, EnumSet } from '@gh/core-data';

export const CustomFieldStatus = createEnum('CUSTOM_FIELD_STATUS', {
  Activate: 'ACTIVE',
  Deactivated: 'DEACTIVATED',
});

export type CustomFieldStatus = EnumSet<typeof CustomFieldStatus>;
